/** Minimum number of choices allowed for a Choice custom field */ export const MinChoicesPerCustomField = 2;
/** Maximum number of choices allowed for a Choice custom field */ export const MaxChoicesPerCustomField = 25;
/** Maximum length of a custom field definition display name */ export const MaxCustomFieldDefinitionNameLength = 255;
/** Maximum length of a custom field choice display name */ export const MaxCustomFieldChoiceNameLength = 255;
/** Maximum character length allowed for a Text custom field value */ export const MaxTextCustomFieldValueLength = 4000;
/** Maximum value allowed for a Number custom field */ export const MaxNumberCustomFieldValue = 999999999999999;
/** Minimum value allowed for a Number custom field */ export const MinNumberCustomFieldValue = -999999999999999;
/** Whether the custom field definition popover is in add or edit mode */ export var CustomFieldDefinitionMode = /*#__PURE__*/ function(CustomFieldDefinitionMode) {
    CustomFieldDefinitionMode["Add"] = "add";
    CustomFieldDefinitionMode["Edit"] = "edit";
    return CustomFieldDefinitionMode;
}({});
